import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import celularFlat from "../../assets/celular-flat.svg";
import { useAuth } from "../../context/AuthContext";
import UseConfirmacaoTelefone from "../../hooks/UseConfirmacaoTelefone/UseConfirmacaoTelefone";

const API_URL = process.env.REACT_APP_API_URL;

const ConfirmacaoTelefone = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const intervalId = setInterval(() => {
      if (document.body.style.overflow !== "hidden") {
        document.body.style.overflow = "hidden";
      }
    }, 100);

    return () => {
      clearInterval(intervalId);
      document.body.style.overflow = "unset";
    };
  }, []);

  const { setUser } = useAuth();

  const telefone = location.state?.telefone || "";

  useEffect(() => {
    if (!telefone) {
      navigate("/cadastro");
    }
  }, [telefone, navigate]);

  const {
    code,
    timer,
    loading,
    error,
    success,
    handleChange,
    handleKeyDown,
    handlePaste,
    verifyCode,
    generateCode,
  } = UseConfirmacaoTelefone({
    telefone,
    onVerified: (usuario) => {
      setUser(usuario);
      navigate("/dashboard");
    },
  });

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && !loading) {
        e.preventDefault();
        verifyCode(e);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [loading, verifyCode]);

  return (
    <>
      <style>{`
        .ev-page {
          height: calc(100dvh - 80px);
          overflow-y: auto;
          overflow-x: hidden;
          display: block;
          flex-direction: column;
        }

        .ev-container {
          min-height: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 24px 16px;
          max-width: 900px;
          width: 100%;
          margin: 0 auto;
          text-align: center;
          box-sizing: border-box;
          gap: 16px;
        }

        .ev-image {
          max-height: 180px;
          object-fit: contain;
          flex-shrink: 0;
        }

        .ev-title {
          color: #00bcd4;
          font-size: clamp(20px, 2.2vw, 28px);
          font-weight: 700;
          margin-top: -15px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-wrap: wrap;
          line-height: 1.2;
        }

        .ev-subtitle {
          color: #757575;
          font-size: clamp(14px, 1.5vw, 16px);
          line-height: 1.5;
          max-width: 560px;
          margin-top: -25px;
        }

        .ev-input.error {
          border: 2px solid #f8b4b4 !important;
          background-color: #fde8e8;
          animation: shake 0.2s ease-in-out 0s 2;
        }

        @keyframes shake {
          0% { margin-left: 0; }
          25% { margin-left: 5px; }
          75% { margin-left: -5px; }
          100% { margin-left: 0; }
        }

        .ev-alert {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 16px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          width: fit-content;
          margin: -15px auto 15px;
          gap: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }

        .ev-alert-error {
          background-color: #fde8e8;
          color: #c81e1e;
          border: 1px solid #f8b4b4;
        }

        .ev-alert-success {
          background-color: #def7ec;
          color: #03543f;
          border: 1px solid #bcf0da;
        }


        .ev-inputGroup {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          margin-top: -20px;
          justify-content: center;
        }

        .ev-input {
          width: clamp(44px, 8vw, 54px);
          height: clamp(44px, 8vw, 54px);
          font-size: clamp(18px, 2vw, 22px);
          text-align: center;
          border-radius: 12px;
          border: none;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          outline: none;
          box-sizing: border-box;
        }

        .ev-button {
          width: 100%;
          max-width: 260px;
          padding: 12px 16px;
          background: linear-gradient(90deg, #1a7fe7, #19c4c9, #0ed079);
          color: white;
          border: none;
          border-radius: 25px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          opacity: ${loading ? 0.7 : 1};
        }

        .ev-button:hover {
          background: #0ed079ff 100%;
        }

        .ev-timerText {
          color: #9e9e9e;
          font-size: 14px;
          margin: 0;
        }

        .ev-link {
          color: #007bff;
          cursor: pointer;
          text-decoration: underline;
        }

        .ev-message {
          font-size: 14px;
          margin: 0;
        }

        .ev-error {
          color: #d32f2f;
        }

        .ev-success {
          color: #2e7d32;
        }

        @media (max-height: 720px) {
          .ev-container {
            justify-content: flex-start;
            padding-top: 18px;
            padding-bottom: 18px;
          }
        }

        @media (max-width: 480px) {
          .ev-container {
            gap: 13px;
            padding: 18px 14px;
          }

          .ev-inputGroup {
            gap: 10px;
          }
        }
      `}</style>

      <div className="ev-page">
        <div className="ev-container">
          <img src={celularFlat} alt="Meu Ícone" className="ev-image" />

          <h1 className="ev-title">
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#19c4c9"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ position: "relative", top: 2, flexShrink: 0 }}
            >
              <path d="M5 17l5-5-5-5" />
              <path d="M13 17l5-5-5-5" />
            </svg>
            Confirmação de telefone
          </h1>

          <p className="ev-subtitle">
            Um código foi enviado ao número {telefone || "seu telefone"}
            <br />
            Numero errado? <span className="ev-link">alterar número</span>
            <br />
            <br />
            Por favor, verifique seu celular e digite o código no campo
            abaixo{" "}
          </p>

          {error && (
            <div className="ev-alert ev-alert-error">
              <svg
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              {error}
            </div>
          )}

          {success && (
            <div className="ev-alert ev-alert-success">
              <svg
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              {success}
            </div>
          )}

          <div className="ev-inputGroup" onPaste={handlePaste}>
            {code.map((data, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength="1"
                className={`ev-input ${error ? "error" : ""}`}
                value={data}
                onChange={(e) => handleChange(e.target, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onFocus={(e) => e.target.select()}
              />
            ))}
          </div>

          <button className="ev-button" onClick={verifyCode} disabled={loading}>
            {loading ? "VERIFICANDO..." : "VERIFICAR"}
          </button>

          <label
            style={{
              background: "transparent",
              fontWeight: "normal",
              fontSize: 14,
              cursor: "mouse",
              color: "#9e9e9e",
              maxWidth: 260,
              padding: 5,
            }}
          >
            {timer > 0 ? (
              `Aguarde ${timer}s para reenviar o código`
            ) : (
              <label
                onClick={generateCode}
                style={{
                  color: "#0066cc",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                REENVIAR CÓDIGO
              </label>
            )}
          </label>
        </div>
      </div>
    </>
  );
};

export default ConfirmacaoTelefone;
